import React from 'react';
import * as PropTypes from 'prop-types';

import Prescription from './Prescription';

import styles from './styles.styl';

const VisitPrescriptions = ({ prescriptions, formatMessage }) => {
  const title = formatMessage({ id: 'common.prescriptions' });

  return (
    <div className={styles.prescriptionsWrapper}>
      <div className={styles.title}>{title}</div>
      {prescriptions.length
        ? prescriptions.map(prescription => (
            <Prescription
              key={prescription.id}
              prescription={prescription}
              formatMessage={formatMessage}
            />
          ))
        : '-'}
    </div>
  );
};

VisitPrescriptions.propTypes = {
  formatMessage: PropTypes.func,
  prescriptions: PropTypes.array,
};

export default VisitPrescriptions;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitPrescriptions/index.jsx